/**
 * All Store UI Backend API endpoints are defined below
 */

export const CREATE_LEAD = '/v0.1.1/ui/loan/lead';
export const SEND_OTP = '/v0.1.1/ui/otp';
export const VERIFY_OTP = '/v0.1.1/ui/otp/verify';
export const SUBSCRIBER = '/v0.1.1/ui/subscribeEmail';
export const PARTNER_ENQUIRY_FORM = '/v0.1.1/ui/partner_enquiry_form';
export const GET_PINCODE_DETAILS = "/v0.1.1/ui/pin_code/:pin_code/get_details"


// WEBPACK FOOTER //
// ./src/actions/endpoints.js